import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ArrowNextIcon } from '../../icons';
import { useHistory } from 'react-router-dom';

import css from './EditListingWizard.css';
import { isDraft, isNewListing } from './Helpers';
import {
    LISTING_PAGE_PARAM_TYPE_EDIT,
    LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
} from '../../util/urlHelpers';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { getListingNavParams } from '../../util/listings';
import { getEntryDataToRedirectAfterAuth } from '../../util/localStorage';
import BenefitsModal from './Components/BenefitsModal/BenefitsModal';

const HeadingTxt = ({ riderName, params, isListingCompleted }) => {
    const {
        type, // new, edit
        tab, // overview
    } = params;

    if (riderName && isNewListing(params)) {
        return <span>{riderName} wartet bereits auf deine Anfrage!</span>;
    }

    return (
        <FormattedMessage
            id={
                isListingCompleted
                    ? 'EditListingWizard.titleCompleted'
                    : `EditListingWizard.title-${type}-${tab}`
            }
        />
    );
};

const DescTxt = ({ riderName, params, isListingCompleted }) => {
    const {
        type, // new, edit
        tab, // overview
    } = params;

    if (riderName && isNewListing(params)) {
        return (
            <>
                <span>
                    Fast geschafft! Mit ein paar weiteren Angaben klappt das Matching perfekt.
                </span>{' '}
                <BenefitsModal riderName={riderName} />
            </>
        );
    }

    return (
        <FormattedMessage
            id={
                isListingCompleted
                    ? 'EditListingWizard.subtitleCompleted'
                    : `EditListingWizard.subTitle-${type}-${tab}`
            }
        />
    );
};

const EditListingWizardInfo = ({
    showTabs,
    params,
    currentListing,
    isListingCompleted,
    redirectParams = {},
}) => {
    const {
        type, // new, edit
        tab, // overview
    } = params;
    const history = useHistory();

    if (!showTabs) return null;

    const entryToRedirectAfterAuth = getEntryDataToRedirectAfterAuth() || {};
    const { riderName } = entryToRedirectAfterAuth?.redirectAfterAuthInquiryData || {};

    const navigate = (params, name) =>
        history.push(createResourceLocatorString(name, routeConfiguration(), params));

    const moveBack = () => {
        const listingExists = Boolean(currentListing?.id?.uuid);

        if (
            listingExists &&
            (type === LISTING_PAGE_PARAM_TYPE_EDIT ||
                type === LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT)
        ) {
            const { params, name } = getListingNavParams(currentListing);

            navigate(params, name);
        } else {
            const { name = 'LandingPage', params = {} } = redirectParams || {};
            navigate(params, name);
        }
    };

    return (
        <div className={css.infoContainer}>
            {!isDraft(params) && (
                <div className={css.infoWrapper}>
                    <div className={css.backTitle} onClick={moveBack}>
                        <ArrowNextIcon />
                        <span>Zurück</span>
                    </div>
                </div>
            )}
            <div className={css.infoWrapper}>
                <h1 className={css.infoTitle}>
                    <HeadingTxt
                        riderName={riderName}
                        params={params}
                        isListingCompleted={isListingCompleted}
                    />
                </h1>
            </div>
            <div className={css.infoWrapper}>
                <p className={css.infoSubTitle}>
                    <DescTxt
                        riderName={riderName}
                        params={params}
                        isListingCompleted={isListingCompleted}
                    />
                </p>
            </div>
        </div>
    );
};

export default EditListingWizardInfo;
